import { RouteConfig } from 'vue-router';

import IndexPage from '@/pages/index/IndexPage.vue';
import { editEntryPageRoute } from '@/pages/index/pages/edit/route';
import { newEntryPageRoute } from '@/pages/index/pages/new/route';
import { refreshToken } from '@/router/guards/refreshToken';

export const indexRoute: RouteConfig = {
  beforeEnter: refreshToken,
  meta: {
    title: 'SIR',
  },
  path: '/',
  component: IndexPage,

  // Child route components do get lazy-loaded...
  children: [
    editEntryPageRoute,
    newEntryPageRoute,
  ],
};
